"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdThirdPartyTrackingToJSON = exports.AdThirdPartyTrackingFromJSONTyped = exports.AdThirdPartyTrackingFromJSON = exports.instanceOfAdThirdPartyTracking = exports.AdThirdPartyTrackingMeasurementPartnerEnum = exports.AdThirdPartyTrackingMeasurementEventEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.AdThirdPartyTrackingMeasurementEventEnum = {
    Start: 'START',
    Impression: 'IMPRESSION',
    ViewableImpression: 'VIEWABLE_IMPRESSION',
    FirstQuartile: 'FIRST_QUARTILE',
    Midpoint: 'MIDPOINT',
    ThirdQuartile: 'THIRD_QUARTILE',
    Clicked: 'CLICKED',
    Complete: 'COMPLETE'
};
/**
 * @export
 */
exports.AdThirdPartyTrackingMeasurementPartnerEnum = {
    Ias: 'IAS',
    Dcm: 'DCM',
    Moat: 'MOAT',
    Unset: 'UNSET'
};
/**
 * Check if a given object implements the AdThirdPartyTracking interface.
 */
function instanceOfAdThirdPartyTracking(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdThirdPartyTracking = instanceOfAdThirdPartyTracking;
function AdThirdPartyTrackingFromJSON(json) {
    return AdThirdPartyTrackingFromJSONTyped(json, false);
}
exports.AdThirdPartyTrackingFromJSON = AdThirdPartyTrackingFromJSON;
function AdThirdPartyTrackingFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'measurementEvent': !(0, runtime_1.exists)(json, 'measurement_event') ? undefined : json['measurement_event'],
        'measurementPartner': !(0, runtime_1.exists)(json, 'measurement_partner') ? undefined : json['measurement_partner'],
        'url': !(0, runtime_1.exists)(json, 'url') ? undefined : json['url'],
    };
}
exports.AdThirdPartyTrackingFromJSONTyped = AdThirdPartyTrackingFromJSONTyped;
function AdThirdPartyTrackingToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'measurement_event': value.measurementEvent,
        'measurement_partner': value.measurementPartner,
        'url': value.url,
    };
}
exports.AdThirdPartyTrackingToJSON = AdThirdPartyTrackingToJSON;
